import { section } from '@/glow';
import { AnimateBlog } from '@/lib/animation';

section('blog', {
  onLoad() {
    this.AnimateBlog = AnimateBlog(this.container);
  },

  onUnload() {
    this.AnimateBlog?.destroy();
  },
});
